import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useInViewport } from "../../../hooks/useInViewPort";
import { actions, useAppDispatch, useAppSelector } from "../../../redux";
import { ROUTES } from "../../../utills/routes";
import { HEADER_Z_INDEX } from "../../../utils";
import { FlexRow } from "../../Common/Styles";
import { JoinNowAndSignInButtons } from "./JoinNowAndSignInButtons";
import { MenuItems } from "./MenuItems";
import { ProfileAndNotifications } from "./ProfileAndNotifications";

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isInViewport = useInViewport("create-post-container");
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  const loggedInRight = (
    <Right>
      <FlexRow $gapInPx={16} className="header-right-container">
        {!isInViewport && (
          <Components.Button
            color="Primary"
            size="Medium"
            kind="Primary"
            disabled={false}
            label="Create"
            iconPosition="right"
            iconType="Plus"
            onClick={() => dispatch(actions.posts.setCreatePostOpen(true))}
          />
        )}
        <Inputs.Search
          fieldName="header-search"
          idPrefix="header"
          isRequired={false}
          onChangeHandler={() => {}}
          value=""
          placeholder="Search"
          size="Medium"
          handleSelect={() => {}}
        />
      </FlexRow>
      <ProfileAndNotifications />
    </Right>
  );
  const loggedOutRight = (
    <Right>
      <JoinNowAndSignInButtons />
    </Right>
  );

  return (
    <Container className="header-container">
      <Left className="header-left-container">
        <DittoLogo
          src="/images/header/dittoLogo.svg"
          alt="Ditto "
          onClick={() => navigate(ROUTES.home)}
        />
        {isAuthenticated && <MenuItems />}
      </Left>
      {isAuthenticated ? loggedInRight : loggedOutRight}
    </Container>
  );
};

const Container = styled.div`
  height: 72px;
  padding: 0 52px;
  display: flex;
  position: sticky;
  top: 0;
  z-index: ${HEADER_Z_INDEX};
  flex-direction: row;
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
const DittoLogo = styled.img`
  height: 40px;
  cursor: pointer;
`;
const Left = styled.div`
  display: flex;
  flex-direction: row;
  gap: 98px;
  align-items: center;
`;
const Right = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 60px;
`;
